import React from 'react';
import { HomePage, type ManagementCardInfo } from '../../../components';

export const SuperAdminHomePage: React.FC = () => {
  const Cards: ManagementCardInfo[] = [
    {
      title: 'User Management',
      caseName: 'User Management',
      caseNumber: 0,
      backgroundColor: '#951D1D',
      navLink: '/internal/super-admin/user-management',
    },
    {
      title: 'Configuration Management',
      backgroundColor: '#951D1D',
      navLink: '/internal/super-admin/configuration-management',
    },
    {
      title: 'Organization Management',
      backgroundColor: '#951D1D',
      navLink: '/internal/super-admin/organization-management',
    },
    {
      title: 'Ad-hoc Tools',
      backgroundColor: '#951D1D',
      navLink: '/internal/super-admin/adhoc-tools',
    },
    {
      title: 'Applicant Information Update',
      backgroundColor: '#951D1D',
      navLink: '/internal/super-admin/applicant-information-update',
    },
  ];

  return (
    <div>
      <HomePage managementCards={Cards} />
    </div>
  );
};
